module.exports = __webpack_public_path__ + "img/icon_about_09.6ea93195.png";